module.exports = __webpack_public_path__ + "site/img/processing_cn-01.6b27941d.jpg";